class DomReadMore extends HTMLElement {
  connectedCallback() {
    this.fullContent = this.querySelector('.read-more__full-description')
    this.readMore = this.querySelector('.read-more__show')
    this.readLess = this.querySelector('.read-more__hide')
    this.toggle = this.toggle.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)

    this.readMore.addEventListener('click', this.toggle)
    this.readLess.addEventListener('click', this.toggle)
    this.readMore.addEventListener('keydown', this.handleKeyDown)
    this.readLess.addEventListener('keydown', this.handleKeyDown)
  }
  disconnectedCallback() {
    this.readMore.removeEventListener('click', this.toggle)
    this.readLess.removeEventListener('click', this.toggle)
    this.readMore.removeEventListener('keydown', this.handleKeyDown)
    this.readLess.removeEventListener('keydown', this.handleKeyDown)
  }

  handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.toggle()
    }
  }

  toggle = () => {
    this.readMore.classList.toggle('hidden')
    this.readLess.classList.toggle('hidden')
    this.fullContent.classList.toggle('hidden')

    setTimeout(() => {
      this.moveFocus()
    }, 100)
  }

  moveFocus() {
    const targetButton = !this.readMore.classList.contains('hidden')
      ? this.readMore
      : this.readLess

    // Focus on the shadow root's internal button or link
    const shadowRoot = targetButton.shadowRoot
    if (shadowRoot) {
      const focusableElement = shadowRoot.querySelector('button, a')
      if (focusableElement) {
        focusableElement.focus()
      }
    } else {
      targetButton.focus()
    }
  }
}
customElements.define('dom-read-more', DomReadMore)
